"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _useScript = _interopRequireDefault(require("../../../useScript"));

var _styles = _interopRequireDefault(require("../../config/styles"));

var _options = _interopRequireDefault(require("../../config/options"));

var _helper = _interopRequireDefault(require("../../helper"));

var _style = _interopRequireDefault(require("../../style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultLocation = {
  //Qmerit
  lat: 33.659917923217414,
  lng: -117.7535490787679
};
var directionsService;
var directionsRenderer;
var mapDirections;

function initMap(_ref) {
  var element = _ref.element,
      target = _ref.target,
      bounds = _ref.bounds,
      props = _ref.props;

  if (element) {
    var options = _objectSpread(_objectSpread({}, _options["default"]["static"]), {}, {
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: _styles["default"]
    });

    mapDirections = new google.maps.Map(element, options);
    var latLng = {
      lat: props.locations[0].lat,
      lng: props.locations[0].lng
    };

    var _bounds = new google.maps.LatLngBounds(latLng);

    if (_lodash["default"].has(props, 'locations') && _lodash["default"].isArray(props.locations)) {
      _helper["default"].createMarkers({
        locations: props.locations,
        bounds: _bounds,
        map: mapDirections
      });
    }

    _helper["default"].getCurrentLocation(function (position) {
      _helper["default"].createMyLocationMarker({
        position: position,
        bounds: _bounds,
        map: mapDirections
      });

      directionsRenderer.setMap(mapDirections);
      calculateAndDisplayRoute(directionsService, directionsRenderer, props.locations[0], position);
    }, function (error) {
      handleLocationError(props, error);
    });
  }
}

function calculateAndDisplayRoute(directionsService, directionsRenderer, location, currentLocation) {
  var origin = new google.maps.LatLng({
    lat: currentLocation.latitude,
    lng: currentLocation.longitude
  }),
      destination = new google.maps.LatLng({
    lat: location.lat,
    lng: location.lng
  });
  directionsService.route({
    origin: origin,
    destination: destination,
    travelMode: 'DRIVING',
    provideRouteAlternatives: true
  }, function (response, status) {
    if (status === 'OK') {
      directionsRenderer.setDirections(response);
    } else {
      console.log(status);
    }
  });
}

function DirectionsMap(props) {
  var mapContainer = /*#__PURE__*/_react["default"].createElement(_style["default"].Wrapper, null, /*#__PURE__*/_react["default"].createElement(_style["default"].Target, {
    id: "newMap"
  }));

  if (props.loaded) {
    if (!_lodash["default"].isNil(google)) {
      directionsService = new google.maps.DirectionsService();
      directionsRenderer = new google.maps.DirectionsRenderer({
        suppressMarkers: true,
        polylineOptions: {
          strokeColor: '#00bcd4',
          strokeWeight: 6,
          strokeOpacity: 0.6
        }
      });
    }

    (0, _react.useEffect)(function () {
      initMap({
        element: document.getElementById('newMap'),
        target: 'newMap',
        props: props
      });
    });
  }

  return mapContainer;
}

DirectionsMap.propTypes = {
  locations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    lat: _propTypes["default"].number.isRequired,
    lng: _propTypes["default"].number.isRequired,
    icon: _propTypes["default"].string.isRequired,
    title: _propTypes["default"].string.isRequired
  }).isRequired).isRequired
};
var _default = DirectionsMap;
exports["default"] = _default;